import moment from 'moment';
import _ from 'lodash';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import { connect } from 'react-redux';
import * as analyticsActions from '../../../../redux/analytics/actions.analytics';
import React, { useCallback } from 'react';
import formats from '../../../../const/formats';
import device from '../../../../services/mini/device';
import ConfirmPopup from '../../../components/ConfirmPopup/ConfirmPopup';
import PlanBodyFiller from '../../plans/PlanBodyFiller';
import BillingTileHeader from '../BillingTileHeader/BillingTileHeader';
import BillingTileLink from '../BillingTileLink/BillingTileLink';
import BillingButton from '../BillingButton/BillingButton';
import PaymentCardInfo from '../PaymentCardInfo/PaymentCardInfo';
import ChangePaymentCardPopup from '../ChangePaymentCardPopup/ChangePaymentCardPopup';
import store from '../../../../store';
import { pages, actions } from '../../../../const/plansAnalytics';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import { routeInfo } from '../../../../routeInfo';

function BillingCurrentPlan({
    cards,
    plan,
    paidUntilTs,
    cancelPlanTs,
    plansCount,
    cancelEnterpriseSubscription,
    resumeEnterpriseSubscription,
    trackPlanAction
}) {
    const isDesktop = device.isDesktop();
    const showCancelSubscriptionLink = plan.isEnterprise && !cancelPlanTs;

    const changeCardCb = useCallback(() => {
        trackPlanAction({ page: pages.billing, action: actions.openChangeCardPopup });
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ChangePaymentCardPopup
                        trackPlanAction={trackPlanAction}
                        store={store}
                        onClose={() => {
                            trackPlanAction({ page: pages.billing, action: actions.closeChangeCardPopup });
                            onClose();
                        }} />
                );
            }
        });
    }, [trackPlanAction]);

    const resumePlanCb = useCallback(() => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ConfirmPopup
                        onClose={onClose}
                        okBtnLabel="Resume"
                        okBtnCb={() => {
                            onClose();
                            trackPlanAction({ page: pages.billing, action: actions.resumePlan });
                            resumeEnterpriseSubscription();
                        }}
                        title="Resume Enterprise Subscription"
                        message={<div>Are you sure you want to resume your Enterprise Subscription? If you resume it, you will be charged again in the next payment period.</div>}
                    />
                );
            }
        });
    }, [resumeEnterpriseSubscription, trackPlanAction]);

    const cancelPlanCb = useCallback(() => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ConfirmPopup
                        onClose={onClose}
                        okBtnLabel="Yes"
                        cancelBtnLabel="No"
                        okBtnCb={() => {
                            onClose();
                            trackPlanAction({ page: pages.billing, action: actions.cancelPlan });
                            cancelEnterpriseSubscription({ planId: plan.id });
                        }}
                        title="Cancel Enterprise Subscription"
                        message={<div>Are you sure you want to cancel your Enterprise Subscription?</div>}
                    />
                );
            }
        });
    }, [plan.id, cancelEnterpriseSubscription, trackPlanAction]);

    const withLogo = plan?.websiteDescription?.indexOf('plan-logo') > 0;
    const isExternalPayment = plan.isExternalPayment;

    const activeCard = _.find(cards, { isActive: true });
    const showCardInfo = activeCard && plan.isPeriodic;

    return <div className="billing-current-plan">
        <BillingTileHeader>
            Current Plan
            {showCancelSubscriptionLink && <div onClick={cancelPlanCb} className="billing-current-plan_cancel-subscription">
                (cancel subscription)
            </div>}
        </BillingTileHeader>
        <div className={`billing-current-plan_content ${!isDesktop && 'mobile'}`}>
            <div className={`billing-current-plan_plan-wrapper ${!isDesktop && 'mobile'} ${withLogo && 'with-logo'} ${isExternalPayment && 'no-price'}`}>
                <PlanBodyFiller plan={plan} />
            </div>
            {plansCount > 1 &&
                <BillingButton title="Change Plan " to={routeInfo.plans.path} className="billing-current-plan_change-plan-link" />}
        </div>

        {showCardInfo && <div className="billing-current-plan_payment-info">
            {(paidUntilTs > 0 && !cancelPlanTs) &&
                <div className={`billing-current-plan_next-payment ${!isDesktop && 'mobile'}`}>
                    <span>Next billing date</span>
                    <b>{moment(paidUntilTs).format(formats.paymentDate)}</b>
                </div>}
            <div className={`billing-current-plan_next-payment with-rows ${!isDesktop && 'mobile'}`}>
                <div>Your current card</div>
                <PaymentCardInfo {...activeCard} />
            </div>
        </div>}
        {showCardInfo && <BillingButton title="Change Card " onClick={changeCardCb} />}

        {cancelPlanTs > 0 && <div
            className={`billing-current-plan_next-payment ${!isDesktop && 'mobile'}`}>
            <div>
                <div>
                    Subscription canceled&nbsp;
                    {isDesktop && <span onClick={resumePlanCb} className="billing-current-plan_resume-subscription">
                        (resume)
                    </span>}
                    <div className="billing-current-plan_info">
                        <i className="icon icon-alan-info-sign" /> Your subscription has been cancelled, and you will not be charged again. You will retain access to all functionality provided by your subscription until the next renewal date ({moment(paidUntilTs).format(formats.paymentDate)}). On that date, the subscription will finally expire.
                    </div>
                </div>
            </div>
        </div>}
    </div>;
}


function mapStateToProps({ user }, ownProps) {
    let tab = '';
    if (ownProps.route && ownProps.route.tab) {
        tab = ownProps.route.tab;
    }

    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
        trackPlanAction: (param) => asyncDispatch(analyticsActions.trackPlanAction, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingCurrentPlan);

